/**
 *  Verifies an entered EAN number (checksum + Nemhandel registry lookup)
 *  before letting the checkout button proceed, on both the cart page and
 *  the cart drawer.
 */
(function () {
  var VERIFY_URL = 'https://boh-ean-invoicing.fourevergreen.workers.dev/verify-ean';
  var EAN_INPUT_IDS = { 'Cart': 'CartEanNumber', 'Cart-Drawer': 'CartDrawerEanNumber' };
  var ERROR_MESSAGES = {
    format: 'EAN-nummeret skal være 13 cifre.',
    checksum: 'EAN-nummeret er ugyldigt (forkert kontrolciffer).',
    not_registered: 'EAN-nummeret er ikke registreret i Nemhandelsregistret.',
    lookup_error: 'Kunne ikke verificere EAN-nummeret lige nu. Prøv igen om lidt.',
  };

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.checkout-button');
    if (!button) return;

    var scope = button.closest('#Cart, #Cart-Drawer');
    if (!scope) return;
    var input = document.getElementById(EAN_INPUT_IDS[scope.id]);
    if (!input) return;

    handleCheckoutClick(event, button, input);
  });

  function handleCheckoutClick(event, button, input) {
    // Re-dispatched click after our own check already passed — let it (and
    // any other click listeners, e.g. the terms checkbox) run normally.
    if (button.dataset.eanVerified === 'true') {
      delete button.dataset.eanVerified;
      return;
    }

    event.preventDefault();
    if (button.disabled) return;

    var ean = input.value.trim();
    button.disabled = true;

    var verification = ean ? verifyEan(ean) : Promise.resolve({ valid: true });

    verification
      .then(function (result) {
        if (!result.valid) {
          alert(ERROR_MESSAGES[result.reason] || 'EAN-nummeret kunne ikke verificeres.');
          button.disabled = false;
          return;
        }
        // Also clears a stale attribute when the field was emptied out.
        return setEanAttribute(ean).then(function () {
          button.dataset.eanVerified = 'true';
          button.disabled = false;
          button.click();
        });
      })
      .catch(function () {
        alert(ERROR_MESSAGES.lookup_error);
        button.disabled = false;
      });
  }

  function verifyEan(ean) {
    return fetch(VERIFY_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ean: ean }),
    }).then(function (res) {
      return res.json();
    });
  }

  function setEanAttribute(ean) {
    return fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { EAN_number: ean } }),
    });
  }
})();
